module.exports = __webpack_public_path__ + "img/hint2.50529309.png";